const localStorage = window.localStorage;
let tokenStorageInstance = null;

export class TokenStorage {
  constructor() {
    if (!tokenStorageInstance) {
      tokenStorageInstance = this;
    }

    return tokenStorageInstance;
  }

  setToken(token) {
    localStorage.setItem('FIFLBOX.token', token);
  }

  deleteToken() {
    localStorage.removeItem('FIFLBOX.token');
  }

  getToken() {
    return localStorage.getItem('FIFLBOX.token');
  }

  getBearerToken() {
    let token = localStorage.getItem('FIFLBOX.token');

    if (!token) {
      return null;
    }

    return 'Bearer ' + localStorage.getItem('FIFLBOX.token');
  }

  hasToken() {
    return localStorage.getItem('FIFLBOX.token') !== null;
  }
}
